import React from 'react';
import {Link} from 'react-router-dom';

export const Logo = props => {
    return (
        <div className="row">
            <div className=" col-lg-12  col-sm-12 col-xs-12 ">
                <Link to="/dashboard">
                    <img className="img-responsive panelLogo" alt={'Bettair'} src={props.Logo}/>
                </Link>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/components/Map/Common/Logo.js